import { Entreprise } from './entreprise.model';
import { CaracteristiqueParcelle } from './caracteristique-parcelle.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Localisation {
    static jsonMap = {
        id: { key: 'id', optional: true },
        entreprise: { key: 'entreprise', converter: new (ClassConverterFactory.build(Entreprise))(), optional: true },
        caracteristiqueParcelle: { key: 'caracteristiqueParcelle', converter: new (ClassConverterFactory.build(CaracteristiqueParcelle))(), optional: true },
        departement: { key: 'departement', optional: true, default: '' },
        codePostal: { key: 'codePostal', optional: true, default: '' },
        commune: { key: 'commune', optional: true, default: '' },
        lieuDit: { key: 'lieuDit', optional: true, default: '' },
        referenceCadastrale: { key: 'referenceCadastrale', optional: true, default: '' },
        surfaceCadastrale: { key: 'surfaceCadastrale', optional: true },
        desactive: { key: 'desactive', optional: true },
        nbBloc: { key: 'nbBloc', optional: true }
    };

    public id: number = undefined;
    public entreprise: Entreprise = undefined;
    public caracteristiqueParcelle: CaracteristiqueParcelle = undefined;
    public departement: string = undefined;
    public codePostal: string = undefined;
    public commune: string = undefined;
    public lieuDit: string = undefined;
    public referenceCadastrale: string = undefined;
    public surfaceCadastrale: number = undefined;
    desactive: boolean = undefined;
    public nbBloc: number = undefined;
}
